import React from "react";

import CartaoStatus from "./regras/CartaoStatus";
import SecaoAcumulo from "./regras/SecaoAcumulo";
import SecaoDesconto from "./regras/SecaoDesconto";
import SecaoFaixa from "./regras/SecaoFaixa";
import SecaoLimite from "./regras/SecaoLimite";
import SecaoModulos from "./regras/SecaoModulos";
import SecaoParticipantes from "./regras/SecaoParticipantes";

// Regras da campanha. Tudo que muda a experiência do cliente mora aqui; o
// que muda por produto fica na aba Produtos.
export default function SecaoRegras({ ativa, onAtiva, config, onMudarConfig, produtos, participando, onIrParaProdutos }) {
  const mudar = (campo, valor) => onMudarConfig({ ...config, [campo]: valor });
  return (
    <div className="space-y-4">
      <CartaoStatus ativa={ativa} onAtiva={onAtiva} config={config} participando={participando} onIrParaProdutos={onIrParaProdutos} />
      <SecaoModulos config={config} onMudar={mudar} />
      <SecaoDesconto config={config} produtos={produtos} onMudar={mudar} />
      <SecaoLimite config={config} produtos={produtos} onMudar={mudar} />
      <SecaoParticipantes config={config} onMudar={mudar} />
      <SecaoAcumulo config={config} onMudar={mudar} />
      <SecaoFaixa config={config} onMudar={mudar} />
    </div>
  );
}
